import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UserService } from './user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private userService: UserService | null = null;
  private isHandlingAuthError = false;

  constructor(
    private injector: Injector,
    private router: Router
  ) {
    setTimeout(() => {
      this.userService = this.injector.get(UserService);
    });
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle authentication errors (401 Unauthorized only)
        // 403 Forbidden means the token is valid but user lacks permission - do NOT logout
        if (error.status === 401 && this.userService) {
          this.handleAuthError(error);
        }
        return throwError(error);
      })
    );
  }

  private handleAuthError(error: HttpErrorResponse): void {
    if (this.isHandlingAuthError) {
      return;
    }
    if (!this.userService.user_logged_in || this.userService.loggingOut) {
      return;
    }
    console.log('Auth error intercepted:', error.status, error.message);

    this.isHandlingAuthError = true;
    const currentRoute = this.router.url;
    if (currentRoute && currentRoute !== '/' && currentRoute !== '/home') {
      localStorage.setItem('redirectTo', currentRoute);
    }

    localStorage.setItem('sessionExpiredMessage', 'Your session has expired. Please log in again.');

    this.userService.logout();

    setTimeout(() => {
      this.isHandlingAuthError = false;
    }, 1000);
  }
}
